import { useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../oldButton';
import { SelectablePlaylistButton } from '../../../../../modules/musicManagement/shared';
import { ReactComponent as ArrowRight } from '../../../../../assets/icons/arrowRight.svg';
import theme from '../../../../../global/style/theme';

const Back = styled(Button)`
  background-color: transparent;
  color: ${({ theme }) => theme.dark300};
  display: flex;
  align-items: center;
  text-transform: none;
  padding: 0;

  &:hover,
  &:focus {
    & path {
      fill: ${({ theme }) => theme.dark300};
    }
  }

  & p {
    font-size: 0.95rem;
    font-weight: 400;
    padding-left: 0.3rem;
  }
`;

const Body = styled.div`
  border-top: 0.15rem solid ${({ theme }) => theme.stroke};
  margin-bottom: 2rem;
`;

const StyledSelectablePlaylistButton = styled(SelectablePlaylistButton)`
  padding: 1rem 0.8rem 1rem 1rem;

  &:after {
    width: 100%;
  }

  ${({ selected }) =>
    selected &&
    css`
      background-color: ${({ theme }) => theme.babyBlue};
      & p {
        font-weight: 800;
        color: ${({ theme }) => theme.white};
      }
    `}
`;

const ArrowLeft = styled(ArrowRight)`
  transform: rotate(180deg);
`;

const ChannelStep = ({
  channelId,
  goBack,
  next,
  setChannelId,
  setCalendarId,
  isCalendar,
  calendarId,
  tunifyCalendars,
}) => {
  const { t } = useTranslation();

  const handleClickChannel = useCallback(
    (event) => {
      if (isCalendar) {
        setCalendarId(event?.currentTarget?.value);
      } else {
        setChannelId(event?.currentTarget?.value);
      }
      next();
    },
    [next, setChannelId, setCalendarId, isCalendar]
  );

  const channels = useMemo(() => {
    if (isCalendar) {
      return tunifyCalendars.find((calendar) => calendar.id === channelId)
        ?.calendars;
    }
    return tunifyCalendars;
  }, [tunifyCalendars, isCalendar, channelId]);

  return (
    <>
      <p>{t('musicManagement:tunifyBlue.addCollection.infoChannel')}</p>
      <Back emphasis="primary" flavor="icon" onClick={goBack} type="button">
        <ArrowLeft color={theme.dark300} height="0.7rem" width="0.7rem" />
        <p>{t('common:button.back')}</p>
      </Back>
      <Body>
        {channels.map((channel) => (
          <StyledSelectablePlaylistButton
            key={channel.id || channel.calendarId}
            onClick={handleClickChannel}
            selected={calendarId === (channel.id || channel.calendarId)}
            value={channel.id || channel.calendarId}
          >
            <p>{channel?.name ?? channel?.title}</p>
            {!isCalendar ? (
              <ArrowRight
                color={theme.dark300}
                height="0.7rem"
                width="0.7rem"
              />
            ) : null}
          </StyledSelectablePlaylistButton>
        ))}
      </Body>
    </>
  );
};

export default ChannelStep;
